export interface LaunchDarklyFeatureFlags {
  internalTesting: boolean;
}

export function parseFeatureFlags(flags: Partial<LaunchDarklyFeatureFlags>) {
  return {
    internalTesting: flags.internalTesting ?? false,
  };
}

export type FeatureFlags = ReturnType<typeof parseFeatureFlags>;
